export default "__VITE_ASSET__BrsMXWgG__"